import { render, staticRenderFns } from "./ThemePicker.vue?vue&type=template&id=6b67012a"
import script from "./ThemePicker.vue?vue&type=script&lang=js"
export * from "./ThemePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b67012a')) {
      api.createRecord('6b67012a', component.options)
    } else {
      api.reload('6b67012a', component.options)
    }
    module.hot.accept("./ThemePicker.vue?vue&type=template&id=6b67012a", function () {
      api.rerender('6b67012a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/theme-picker/ThemePicker.vue"
export default component.exports